import { render, staticRenderFns } from "./plansSliderSwitch.vue?vue&type=template&id=36ca50be&scoped=true&"
import script from "./plansSliderSwitch.vue?vue&type=script&lang=js&"
export * from "./plansSliderSwitch.vue?vue&type=script&lang=js&"
import style0 from "./plansSliderSwitch.vue?vue&type=style&index=0&id=36ca50be&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ca50be",
  null
  
)

export default component.exports